import { HttpInterceptorFn } from '@angular/common/http';
import { authInterceptor } from './auth.interceptor';
import { collectionIdempotencyInterceptor } from './collection-idempotency.interceptor';

export const collectionFlowInterceptors: ReadonlyArray<HttpInterceptorFn> = [
  authInterceptor,
  collectionIdempotencyInterceptor,
];
